module.exports = {
  __depends__: [
    require(233),
    require(227),
    require(162)
  ],
  connect: [ 'type', require(150) ]
};
